import Vue from 'vue'
import VueWindowSize from 'vue-window-size'

Vue.use(VueWindowSize)



// WEBPACK FOOTER //
// ./src/front/init/utils/windows-size.js